import { INote } from "../types/INote";

export default function prepareRequest(
  notes: INote[],
  length: number,
  oldest: boolean,
  mode?: string,
  first?: boolean
) {
  const initDate: string = oldest ? new Date(0).toJSON() : new Date().toJSON();
  const dateTime: string = length && mode !== "sort" ? notes[length - 1].publicationDate : initDate;

  const endpoint = oldest ? "after" : "before";

  return first ? `notes` : `notes/${endpoint}?dateTime=${dateTime}`;
}
